module.exports = __webpack_public_path__ + "static/img/interstwo.7b1dba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/interstwo.png
// module id = a0Ws
// module chunks = 45